// Shape cards in article guide sections: clicking a card selects it and reveals its description
document.addEventListener('click', (event) => {
  const card = event.target.closest('.guide-shape__card');
  if (!card) return;

  const shape = card.closest('.guide-shape');
  const group = shape.parentElement;

  group.querySelectorAll(':scope > .guide-shape').forEach((item) => {
    const isSelected = item === shape;
    item.classList.toggle('is-active', isSelected);
    item.querySelector('.guide-shape__card')?.setAttribute('aria-pressed', String(isSelected));
  });
});
